<template>
  <div>
    <ValidationObserver ref="observer" tag="form">
      <b-form>
        <div id="tao-nguoi-dung">
          <div class="row">
            <div
              class="col-md-4 col-sm-12"
              :class="laTaoMoi === false || readonly ? 'col-md-12' : ''"
            >
              <b-form-group
                class="required"
                label="Tên người dùng"
                label-for="userName"
                label-class="font-weight-bold"
              >
                <ValidationProvider
                  name="Tên người dùng"
                  rules="required|maxlength:50|code"
                  v-slot="validationContext"
                >
                  <b-form-input
                    id="name"
                    v-model="internalForm.userName"
                    :state="getValidationState(validationContext)"
                    type="text"
                    required
                    :disabled="!laTaoMoi || readonly"
                    placeholder=""
                    :class="{
                      'is-danger': validationContext.errors.length > 0,
                    }"
                  />
                  <b-form-invalid-feedback class="error"
                    >{{ validationContext.errors[0] }}
                  </b-form-invalid-feedback>
                </ValidationProvider>
              </b-form-group>
            </div>
            <div class="col-md-4 col-sm-12">
              <b-form-group
                v-if="laTaoMoi"
                class="required"
                label="Mật khẩu"
                label-for="password"
                label-class="font-weight-bold"
              >
                <ValidationProvider
                  name="Mật khẩu"
                  rules="required|maxlength:50"
                  vid="password"
                  v-slot="validationContext"
                >
                  <b-form-input
                    id="mat-khau"
                    v-model="internalForm.password"
                    type="password"
                    placeholder=""
                    :readonly="!laTaoMoi"
                    rows="2"
                    max-rows="100"
                    no-resize
                    :state="getValidationState(validationContext)"
                    :class="{
                      'is-danger': validationContext.errors.length > 0,
                    }"
                  />
                  <b-form-invalid-feedback class="error"
                    >{{ validationContext.errors[0] }}
                  </b-form-invalid-feedback>
                </ValidationProvider>
              </b-form-group>
            </div>
            <div class="col-md-4 col-sm-12">
              <b-form-group
                v-if="laTaoMoi"
                class="required"
                label="Nhập lại mật khẩu"
                label-for="repeat-password"
                label-class="font-weight-bold"
              >
                <ValidationProvider
                  name="Xác nhận mật khẩu"
                  rules="required|confirmed:password|maxlength:50"
                  v-slot="validationContext"
                >
                  <b-form-input
                    id="repeat-mat-khau"
                    v-model="internalForm.repeatPassword"
                    type="password"
                    placeholder=""
                    :readonly="!laTaoMoi"
                    rows="2"
                    max-rows="100"
                    :state="getValidationState(validationContext)"
                    no-resize
                    :class="{
                      'is-danger': validationContext.errors.length > 0,
                    }"
                  />
                  <b-form-invalid-feedback class="error"
                    >{{ validationContext.errors[0] }}
                  </b-form-invalid-feedback>
                </ValidationProvider>
              </b-form-group>
            </div>
            <b-form-group
              v-if="false"
              class="required"
              label="Số điện thoại"
              label-for="phoneNumber"
              label-class="font-weight-bold"
            >
              <ValidationProvider
                name="Số điện thoại"
                rules="phone_number:8,20"
                v-slot="validationContext"
              >
                <b-form-input
                  type="number"
                  :disabled="laTaoMoi"
                  :state="getValidationState(validationContext)"
                  id="soDienThoai"
                  v-model="internalForm.phoneNumber"
                ></b-form-input>
                <b-form-invalid-feedback class="error"
                  >{{ validationContext.errors[0] }}
                </b-form-invalid-feedback>
              </ValidationProvider>
            </b-form-group>
            <div class="col col-12">
              <b-form-group
                class="required"
                label="Ứng dụng"
                label-for="application"
                label-class="font-weight-bold"
              >
                <ValidationProvider
                  name="Ứng dụng"
                  rules="requiredMultiple"
                  v-slot="validationContext"
                >
                  <MultiSelect
                    :options="danhSachApp"
                    optionLabel="name"
                    optionValue="id"
                    class="w-100"
                    placeholder="Chọn ứng dụng"
                    :state="getValidationState(validationContext)"
                    :class="{
                      'select-invalid is-invalid':
                        validationContext.errors.length > 0,
                    }"
                    :disabled="readonly"
                    v-model="internalForm.applicationIds"
                    display="chip"
                  ></MultiSelect>
                  <b-form-invalid-feedback class="error"
                    >{{ validationContext.errors[0] }}
                  </b-form-invalid-feedback></ValidationProvider
                >
              </b-form-group>
            </div>
            <b-form-group
              class="required"
              label="Email"
              label-for="email"
              v-if="false"
              label-class="font-weight-bold"
            >
              <ValidationProvider
                name="Email"
                rules="email"
                v-slot="validationContext"
              >
                <b-form-input
                  :disabled="laTaoMoi"
                  :state="getValidationState(validationContext)"
                  id="email"
                  v-model="internalForm.email"
                ></b-form-input>
                <b-form-invalid-feedback class="error"
                  >{{ validationContext.errors[0] }}
                </b-form-invalid-feedback>
              </ValidationProvider>
            </b-form-group>
            <div class="col col-md-4 col-sm-12">
              <b-form-group
                label="Đơn vị"
                label-for="don-vi"
                label-class="font-weight-bold"
              >
                <treeselect
                  :disabled="readonly"
                  :readonly="readonly"
                  :clearable="true"
                  :normalizer="normalizer"
                  :options="danhSachDonViBanDau || []"
                  :show-count="true"
                  :value="donViSearchId"
                  no-children-text="Không có đơn vị con"
                  placeholder="Chọn đơn vị"
                  ref="chonCayDonVi"
                  v-model="donViSearchId"
                  @input="layDanhSachCanBoVaoNguoiDung()"
                >
                  <label
                    :class="labelClassName"
                    slot="option-label"
                    slot-scope="{
                      node,
                      shouldShowCount,
                      count,
                      labelClassName,
                      countClassName,
                    }"
                  >
                    {{ node.label }}
                    <span
                      :class="countClassName"
                      v-if="shouldShowCount && count > 0"
                      >({{ count }})</span
                    >
                  </label>
                </treeselect>
              </b-form-group>
            </div>
            <div class="col col-md-4 col-sm-0"></div>
            <div class="col col-md-4 col-sm-12">
              <b-form-group
                label="Cán bộ"
                label-for="can-bo"
                label-class="font-weight-bold"
              >
                <div class="d-flex align-items-center">
                  <BaseMultipleSelect
                    class="flex-1-0"
                    v-model="internalForm.profileId"
                    :options="
                      danhSachCanBoNoiBo && danhSachCanBoNoiBo.map((x) => x.id)
                    "
                    placeholder="Chọn cán bộ"
                    :internalSearch="false"
                    :custom-label="
                      (opt) =>
                        getLabelCustom(
                          danhSachCanBoNoiBo &&
                            danhSachCanBoNoiBo.find((x) => x.id === opt)
                        )
                    "
                    :is-disabled="readonly"
                    @onChange="internalForm.profileId = $event"
                    @onTyping="onSearchSelect"
                  />
                  <b-icon
                    v-if="!internalForm.profileId"
                    icon="plus-circle-fill"
                    class="ml-2 cursor-pointer"
                    scale="1.2"
                    v-b-popover.hover.top="'Tạo mới cán bộ'"
                    @click="goToTaoMoiCanBo"
                    variant="success"
                  ></b-icon>
                </div>
              </b-form-group>
            </div>
          </div>
        </div>
      </b-form>
    </ValidationObserver>
    <ThemThongTinCanBoModal
      ref="themThongTinCanBoModal"
      @pushCanBoToForm="pushCanBoToForm"
    />
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { Treeselect } from "@riophae/vue-treeselect";
import "@riophae/vue-treeselect/dist/vue-treeselect.css";
import _isEmpty from "lodash/isEmpty";
import _cloneDeep from "lodash/cloneDeep";
import debounce from "lodash/debounce";
import BaseMultipleSelect from "@/components/common/BaseMultipleSelect";
import ThemThongTinCanBoModal from "@/components/pages/quan-tri-he-thong/nguoi-dung/ThemThongTinCanBoModal";
const defaultForm = {
  userName: "",
  email: "",
  password: "",
  phoneNumber: "",
  profileId: null,
};
export default {
  name: "FomNguoiDung",
  components: {
    Treeselect,
    BaseMultipleSelect,
    ThemThongTinCanBoModal,
  },
  data() {
    return {
      password: "",
      passwordConfirm: "",
      internalForm: _cloneDeep(defaultForm),
      donViSearchId: null,
      idCanBo: null,
      defaultId: "00000000-0000-0000-0000-000000000000",
      danhSachCanBoNoiBo: [],
    };
  },
  computed: {
    ...mapGetters({
      danhSachApp: "app/tatCaApp",
      danhSachDonVi: "donVi/danhSachDonVi",
    }),
    danhSachDonViBanDau() {
      if (!this.danhSachDonVi) {
        return [];
      }
      let danhSach = [];
      danhSach = this.danhSachDonVi.map((item) => {
        return {
          Task_ID: item.id,
          Task_Parent_ID: item.iD_DonVi_Cha,
          Label: item.tenDonVi,
          Childrens: [],
          ...item,
        };
      });
      return this.list_to_tree(danhSach);
    },
  },
  props: {
    form: {
      // eslint-disable-next-line vue/require-prop-type-constructor
      type: Object | null,
      required: false,
    },
    danhSachCanBo: {
      type: Array,
      default: () => {
        return [];
      },
    },
    laTaoMoi: {
      // eslint-disable-next-line vue/require-prop-type-constructor
      type: Boolean | null,
      required: false,
      default: () => {
        return null;
      },
    },
    readonly: {
      // eslint-disable-next-line vue/require-prop-type-constructor
      type: Boolean | null,
      required: false,
      default: () => {
        return null;
      },
    },
  },
  watch: {
    form: {
      handler() {
        if (this.$route.params.id === "tao-moi") {
          this.internalForm = _cloneDeep(defaultForm);
        } else {
          this.internalForm = Object.assign({}, this.internalForm, this.form);
          if (this.form.profileId === this.defaultId) {
            this.internalForm.profileId = null;
          }
        }
      },
      immediate: true,
    },
    danhSachCanBo: {
      handler() {
        this.danhSachCanBoNoiBo = _cloneDeep(this.danhSachCanBo);
      },
      deep: true,
    },
  },
  methods: {
    getLabelCustom(canBo) {
      return `${canBo?.hoTen} ${
        canBo?.hoTenUnSign ? " - " + canBo?.hoTenUnSign : ""
      }`;
    },
    goToTaoMoiCanBo() {
      this.$refs["themThongTinCanBoModal"].showModal();
    },
    pushCanBoToForm(canBo) {
      this.danhSachCanBoNoiBo.push(canBo);
      this.internalForm.profileId = canBo.id;
    },
    refreshForm() {
      if (this.$route.params.id === "tao-moi") {
        this.internalForm = _cloneDeep(defaultForm);
      } else {
        this.internalForm = Object.assign({}, this.internalForm, this.form);
        if (this.form.profileId === this.defaultId) {
          this.internalForm.profileId = null;
        }
      }
    },
    getValidationState({ dirty, validated, valid = null }) {
      return dirty || validated ? valid : null;
    },
    getInternalForm() {
      return this.internalForm;
    },
    normalizer(node) {
      return {
        children: _isEmpty(node.children) ? undefined : node.children,
      };
    },
    onSearchSelect(keySearch) {
      const $vm = this;
      this.asyncSearchSelect(
        keySearch,
        "user/layDanhSachCanBoVaoNguoiDung",
        $vm
      );
    },
    asyncSearchSelect: debounce((keySearch, patch, vm) => {
      vm.$store.dispatch(patch, {
        UserId: vm.form.id,
        ID_DonVi: vm.donViSearchId,
        FilterBy: keySearch,
        pageIndex: 1,
        pageSize: 50,
      });
    }, 400),
    layDanhSachCanBoVaoNguoiDung() {
      this.$store
        .dispatch("user/layDanhSachCanBoVaoNguoiDung", {
          UserId: this.form.id,
          ID_DonVi: this.donViSearchId,
          pageIndex: 1,
          pageSize: 50,
        })
        .then(() => {});
    },
    list_to_tree(list) {
      if (list.length > 0) {
        var map = {},
          node,
          roots = [],
          i;
        for (i = 0; i < list.length; i += 1) {
          map[list[i].Task_ID] = i; // initialize the map
          list[i].Childrens = []; // initialize the children
        }
        for (i = 0; i < list.length; i += 1) {
          node = list[i];
          if (node.Task_Parent_ID !== this.guidEmpty) {
            // if you have dangling branches check that map[node.parentId] exists
            if (list[map[node.Task_Parent_ID]] != null) {
              list[map[node.Task_Parent_ID]].Childrens.push({
                id: node.Task_ID,
                label: node.Label,
                parentId: node.Task_Parent_ID,
                children: node.Childrens,
              });
            } else {
              roots.push({
                id: node.Task_ID,
                label: node.Label,
                parentId: node.Task_Parent_ID,
                children: node.Childrens,
              });
            }
          } else {
            roots.push({
              id: node.Task_ID,
              label: node.Label,
              parentId: node.Task_Parent_ID,
              children: node.Childrens,
            });
          }
        }
        return roots;
      }
      return list;
    },
  },
};
</script>


